import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FullScreenLoader from "../FullScreenLoader";
import StepHeader from "../PatientRegister/StepHeader";
import DashboardLayout from "../layout/index";

export default function Labcart() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode } = location.state || {};

  const [cartList, setCartList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const removeLab = async () => {
    const token = localStorage.getItem("auth_token");
     const payload = 
     {
    // "id": 38719,
    patientId: "SNCXD7882P",
    cartId: "CTSNCX20250617103120874"
}
console.log(payload,"jghvbhjbjkb")
    try {
        
         
      const response = await fetch(
        `https://cart-stage.curebay.in/cart/lab/removeLab`,
        {
          method: "POST",
          headers: {
          Authorization: `Bearer ${token}`,
        },
        body: payload,
        }
      );
      const result = await response.json();
     
    } catch (err) {
    } finally {
    }
  };
// useEffect(() =>{
//   removeLab();  
// })
  useEffect(() => {
    if (!patientCode) {
      setError("No patient code provided");
    //   setLoading(false);
      return;
    }

    const fetchCart = async () => {
   
      const token = localStorage.getItem("auth_token");
      try {
        const response = await fetch(
          `https://cart-stage.curebay.in/cart/common/cart-list/${patientCode}`,
          {
            headers: {
                  Authorization: `Bearer ${token}` ,
              // If you need auth:
              // Authorization: `Bearer ${localStorage.getItem("auth_token")}`
            },
          }
        );
      
       const result = await response.json();
        console.log(result.data.carts,"result")
        // assuming the API returns an array of items in `body.data` or directly
        setCartList(result.data.carts);
      } catch (err) {
       
      } finally {
      
      }
    };

    fetchCart();
  }, [patientCode]);

   useEffect(() => {
    

    const getLabdetails = async () => {
         const token = localStorage.getItem("auth_token");
      try {
      
      
           const response = await fetch(
          `https://cart-stage.curebay.in/cart/lab/details?cartId=CTSNCX20250617103120861`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        

        const result = await response.json();
        console.log(result,"jkjkkkkkk")

      } catch (err) {
        console.error("Payment form fetch error:", err);
      }
    };

    getLabdetails();
  }, [cartList]);




  if (loading) return <FullScreenLoader />;

  return (
    <DashboardLayout>
      <div className="min-h-screen px-4 md:pt-10 bg-white">
        <StepHeader />

        {error && (
          <div className="text-red-600 my-4">
            <strong>Error:</strong> {error}
          </div>
        )}

        {!error && (
          <div className="mt-6">
            <h2 className="text-xl font-semibold mb-4">
              Current Cart for {patientCode}
            </h2>
            {/* {cartList.length === 0 ? (
              <p>No items in cart.</p>
            ) : (
              <ul className="space-y-3">
                {cartList.map((item) => (
                  <li
                    key={item.labTestCode}
                    className="border p-4 rounded-lg"
                  >
                    <div className="flex justify-between">
                      <span className="font-medium">{item.labTestName}</span>
                      <span>₹{item.amount}</span>
                    </div>
                    <div className="text-sm text-gray-500">
                      Lab: {item.hospitalId}, Location: {item.locationId}
                    </div>
                  </li>
                ))}
              </ul>
            )} */}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
